
const isDevelop = window.location.hostname.includes('test') || window.location.hostname.includes('localhost');
export const NOTIFICATION_API_URL = isDevelop ? 'https://test.asterx.kz/api-notification' : 'https://asterx.kz/api-notification';
export const AUTH_API_URL = isDevelop ? 'https://test.asterx.kz/api-auth' : 'https://asterx.kz/api-auth';
export const CLIENT_API_URL = isDevelop ? 'https://test.asterx.kz/api-client' : 'https://asterx.kz/api-client';
